import FloatingButtons from "@/src_new/shared/components/FloatingButtons";
import { Outlet } from "react-router-dom";

export default function AppShell() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* <SiteHeader /> */}

      <main className="flex-1">
        <Outlet />
      </main>

      {/* <SiteFooter /> */}
      <FloatingButtons />
    </div>
  );
}
